import { DataTypeSystem } from '@efdigital/ll-addon-data/data-types';
import type { PicklistItem } from '@efdigital/ll-addon-data/types/system/picklist-item';
import { query } from '@warp-drive/utilities/json-api';

import { jsonApiOptions, page } from '../../json-api.ts';

/**
 * Query the picklist items in a group, for feeding the coaching profile
 * editor's specialty/positioning pickers (CoachProfileEditor's
 * `specialtiesQuery` / `positioningQueries`). The addon's TagField runs this
 * through `<Request>`, so it must be a Warp Drive request, not resolved items.
 */
export function queryPicklistItemsByGroupName(
  groupName: string,
  { offset = 0, limit = 500 }: { offset?: number; limit?: number } = {}
) {
  return query<PicklistItem>(
    DataTypeSystem.PicklistItem,
    {
      'filter[group]': groupName,
      ...page({ offset, limit }),
    },
    jsonApiOptions
  );
}
